import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { CmsService } from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { B2bunitService } from 'src/app/service/b2bunit/b2bunit.service';
import { ComponentService } from 'src/app/service/component.service';
import { MyAccountPermissionService } from 'src/app/service/myaccount/my-account-permission.service';
import { StorageService } from 'src/app/service/storage/storage.service';

@Component({
  selector: 'app-myaccount-employee-address',
  templateUrl: './myaccount-employee-address.component.html',
  styleUrls: ['./myaccount-employee-address.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class MyaccountEmployeeAddressComponent implements OnInit, OnDestroy {
  shipToAddressSubscription: Subscription;
  currentPageSubscription$: Subscription;
  resetAddEmployeeFormSubscription$: Subscription;
  hasAddressesUpdated: boolean;
  myAccountShipToAddress: any = [];
  unitAddressList$: any = [];
  userAddresses: any = [];
  defaultValues: any = [];
  employee: string;
  @ViewChildren('addressCheckbox') addressCheckboxes: QueryList<MatCheckbox>;

  @Output() activeAddresses = new EventEmitter<any>();
  @Output() addressHasChanged = new EventEmitter<any>();
  @Output() isAddressSelected = new EventEmitter<boolean>();

  constructor(
    protected b2bunitService: B2bunitService,
    protected cmsService: CmsService,
    protected cdr: ChangeDetectorRef,
    protected myAccountPermissionService: MyAccountPermissionService,
    private storageService: StorageService,
    private componentService: ComponentService
  ) {}

  ngOnInit(): void {
    this.currentPageSubscription$ = this.cmsService
      .getCurrentPage()
      .pipe(take(1))
      .subscribe((page) => {
        this.employee = this.storageService.getSessionStorageItem('useruid');
        if (page.label?.includes('edit-employee')) {
          this.getCurrentUserAddresses(this.employee);
        }
      });

    this.unitAddressList$ = this.getUnitAddress();
    this.isAddressSelected.emit(false);
    this.resetAddEmployeeFormSubscription$ = this.componentService.resetAddEmployeeForm$.subscribe((reset) => {
      if (reset) {
        this.reset();
      }
    });
    this.cdr.detectChanges();
  }

  getCurrentUserAddresses(employee: string) {
    this.userAddresses = [];
    this.shipToAddressSubscription = this.getShipToAddress(employee)
      .pipe(take(1))
      .subscribe((shipToAddress: any) => {
        if (shipToAddress && shipToAddress.addresses.length > 0) {
          shipToAddress.addresses.map((addrs: any) => {
            this.userAddresses.push(addrs);
          });
          for (const key in this.userAddresses) {
            if (key !== null || key !== '') {
              this.myAccountShipToAddress.push(this.userAddresses[key].id);
              this.defaultValues.push(this.userAddresses[key].id);
            }
          }
          this.storageService.setSessionStorageItem('shipToAddresses', JSON.stringify(this.myAccountShipToAddress));
          this.activeAddresses.emit(this.myAccountShipToAddress);
          this.isAddressSelected.emit(true);
          this.cdr.detectChanges();
        }
      });
  }

  // get ALL Address List
  getUnitAddress(): Observable<any> {
    return this.b2bunitService.getB2BUnitAddresses();
  }

  // get Address of user
  getShipToAddress(employee: string): Observable<any> {
    return this.myAccountPermissionService.getShipToAddress(employee);
  }

  onChangeEventFunc(address: any, $event: any) {
    if ($event.checked) {
      this.myAccountShipToAddress.push(address.id);
      this.isAddressSelected.emit(true);
    } else {
      const index = this.myAccountShipToAddress.indexOf(address.id);
      if (index > -1) {
        this.myAccountShipToAddress.splice(index, 1);
        this.isAddressSelected.emit(false);
      }
    }

    const containsAll = (arr1: any, arr2: any) => arr2.every((arr2Item: any) => arr1.includes(arr2Item));
    const sameMembers = (arr1: any, arr2: any) => containsAll(arr1, arr2) && containsAll(arr2, arr1);

    if (sameMembers(this.defaultValues, this.myAccountShipToAddress)) {
      this.hasAddressesUpdated = false;
    } else {
      this.hasAddressesUpdated = true;
    }

    this.activeAddresses.emit(this.myAccountShipToAddress);
    this.addressHasChanged.emit(this.hasAddressesUpdated);
    this.cdr.detectChanges();
  }

  compareValue(address: any, selected: any) {
    for (const idx in selected) {
      if (idx !== null) {
        if (selected[idx].id === address.id) {
          return true;
        }
      }
    }
  }

  reset() {
    this.myAccountShipToAddress = [];
    this.hasAddressesUpdated = false;
    this.unitAddressList$ = this.getUnitAddress();
    this.addressCheckboxes.forEach((checkbox: any) => {
      checkbox.checked = false;
    });
    this.isAddressSelected.emit(false);
    this.activeAddresses.emit(this.myAccountShipToAddress);
    this.addressHasChanged.emit(this.hasAddressesUpdated);
  }

  ngOnDestroy() {
    this.shipToAddressSubscription?.unsubscribe();
    this.currentPageSubscription$?.unsubscribe();
    this.resetAddEmployeeFormSubscription$?.unsubscribe();
  }
}
